import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { GlobalConsumer } from "../../../../context/GlobalContext";
import Marketing from "./Marketing";

const Settings = ({ subSection, onCloseSection }) => {
  const [activeSection, setActiveSection] = useState(subSection || "marketing");
  useEffect(() => {
    if (subSection && activeSection !== subSection) {
      setActiveSection(subSection);
    }
  }, [subSection]);
  return (
    <>
      <Helmet>
        <title>Settings</title>
        <meta property="og:title" content="Settings" />
      </Helmet>
      {activeSection === "marketing" && (
        <GlobalConsumer>
          {({ user, updateUser }) => {
            return (
              <Marketing
                onCloseSection={onCloseSection}
                updateUser={updateUser}
                notificationSettings={user.notificationSettings || {}}
              />
            );
          }}
        </GlobalConsumer>
      )}
    </>
  );
};

export default Settings;
